/* eslint-disable import/prefer-default-export */
export { default as getFormattedPaginationLinkURL } from './getFormattedPaginationLinkURL';
